import React from 'react';

import { IconButton, Typography, Stack } from '@mui/material';
import { BackspaceOutlined as BackspaceIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { selectRole } from '../../../../core/auth/selectors';
import { useSelector } from 'react-redux';
import { ROLE, roleRouteMap } from '../../../../core/auth/role.constant';

//import { useNavigationFrom } from '../../hooks/useNavigationFrom';

interface Props {
  title: string;
}

function PageHeaderBar({ title }: Props) {
  const navigate = useNavigate()
  const currentRole: ROLE = useSelector(selectRole);

  const navigateBack = () => {
    navigate(roleRouteMap[currentRole]);
    // window.location.reload();
  };

  return (
    <>
      <Stack direction="row" alignItems="center" mb={1} gap={1}>
        <IconButton onClick={navigateBack}>
          <BackspaceIcon />
        </IconButton>
        <Typography variant="h6" component="h2" color={'#666767'}>
          {title}
        </Typography>
      </Stack>
    </>
  );
}

export default PageHeaderBar;
